import { useNavigate } from "react-router-dom";
import { FEATURES } from "@/pages/FeaturesGuidePage";

export default function AboutAppPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" data-testid="about-app-page">
      {/* Hero */}
      <div className="relative overflow-hidden bg-gradient-to-r from-teal-700 via-emerald-700 to-teal-600">
        <div className="relative z-10 py-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              ToDays Kidz Simple Sign-In
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Everything your childcare center needs — sign-in, compliance, ratios, staff, billing and
              parent communication — all in one place.
            </p>
            <button
              onClick={() => navigate("/pricing")}
              className="mt-6 inline-flex items-center px-6 py-3 rounded-full bg-white text-teal-700 font-semibold hover:bg-teal-50 transition"
              data-testid="about-view-pricing-btn"
            >
              View Pricing
            </button>
          </div>
        </div>
      </div>

      {/* Feature list */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-6">
        {FEATURES.map((f, idx) => {
          const Icon = f.icon;
          const [title, ...rest] = f.marketing.split("\n\n");
          return (
            <div
              key={idx}
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
              data-testid={`about-feature-card-${idx}`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 rounded-xl ${f.bg} flex items-center justify-center shrink-0`}>
                  <Icon className={`w-5 h-5 ${f.color}`} />
                </div>
                <div className="flex-1">
                  <h2 className="text-lg font-bold text-slate-800 mb-2">{title}</h2>
                  {rest.map((para, pIdx) => {
                    if (para.trim().startsWith("Key Benefits:")) {
                      const [, ...bullets] = para.split("\n");
                      return (
                        <ul key={pIdx} className="mt-2 space-y-1.5">
                          {bullets.filter(Boolean).map((b, bIdx) => (
                            <li key={bIdx} className="text-sm text-slate-600 flex gap-2">
                              <span className="text-emerald-500 mt-0.5">•</span>
                              <span>{b.replace(/^-\s*/, "")}</span>
                            </li>
                          ))}
                        </ul>
                      );
                    }
                    return (
                      <p key={pIdx} className="text-sm text-slate-600 leading-relaxed">
                        {para}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer CTA */}
      <div className="bg-white border-t border-slate-200 py-10 px-4 text-center">
        <p className="text-slate-600 mb-4">Ready to see it in action for your center?</p>
        <button
          onClick={() => navigate("/pricing")}
          className="px-6 py-3 rounded-full bg-teal-600 text-white font-semibold hover:bg-teal-700 transition"
          data-testid="about-footer-pricing-btn"
        >
          View Plans & Pricing
        </button>
      </div>
    </div>
  );
}
